export const RESET_ENCRYPTED_RESOURCE = 'RESET_ENCRYPTED_RESOURCE';
export const SET_ENCRYPTED_RESOURCE = 'SET_ENCRYPTED_RESOURCE';